import Papa from 'papaparse';
import React from 'react';
import { useState, useEffect } from 'react';
import quotesCsv from './quotes.csv';

function Quotes() {
    const [current, setCurrent] = useState(null);

    useEffect(() => {
        Papa.parse(quotesCsv, {
            download: true,
            header: true,
            complete: (result) => {
                const data = result.data.filter(row => row.Author && row.Quote);                
                 if (data.length > 0) {
                    const random = data[Math.floor(Math.random() * data.length)];
                    setCurrent(random);
                    const timer = setInterval(() => {
                        const random = data[Math.floor(Math.random() * data.length)];
                        setCurrent(random);
                    }, 60000); // Cambia citazione ogni 15 secondi
                    return () => clearInterval(timer); // Pulisce l'intervallo al dismontaggio del componente
                }
      },
    });
  }, []);

  
    if (!current) return <div>Loading...</div>; 

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100px',  // Altezza per centraggio verticale
            gap: '10px',
            padding: '20px'
        }}>
            <span style={{ fontSize: '26px', fontFamily: "'Satisfy', cursive", whiteSpace: 'nowrap' }}>
                {current.Quote}
            </span>
            <span style={{ fontSize: '20px', fontFamily: "'Satisfy', cursive", whiteSpace: 'nowrap', alignSelf: 'flex-end' }}>
                {current.Author}
            </span>
        </div>
    );
}

export default Quotes;